import { format } from 'date-fns';
import React from 'react';

import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import Cup from '../../assets/leaderboard.svg';

import styles from './Completed.scss';

const Completed: React.FC<CasinoRace & { onStanding(): void | Promise<void> }> = ({
  id,
  name,
  endTime,
  leaderboard = [],
  onStanding = () => undefined
}) => (
  <>
    <div className={styles.info} onClick={onStanding}>
      <span className={styles.name}>{name}</span>
      <span className={styles.date}>{format(endTime, 'dd/LL/yyyy - HH:mm')}</span>
    </div>
    {leaderboard.length && (
      <div className={styles.expand} onClick={onStanding}>
        <div className={styles.cup}>
          <Cup />
        </div>
      </div>
    )}
  </>
);

export default Completed;
